import React from 'react';
import PropTypes from 'prop-types';
import { useTrackVisibility } from 'react-intersection-observer-hook';
import { getColorStyles } from '$utilities/data';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleGraphItem = ({
    description,
    title,
    graphData,
    graphColors,
    graphLabels,
    singleGraphEditorialVariant
}) => {
    const [ref, { wasEverVisible }] = useTrackVisibility();
    const rx = /([\d|.]+)/g;
    let match, output = [];

    const graphBg = singleGraphEditorialVariant ? '#FFFFFF' : '#F3F2ED';

    const gradientStyle = {
        background: `repeating-linear-gradient(to bottom, #4040401A, #4040401A 1px, ${graphBg} 1px, ${graphBg} 25%)`
    };

    {graphData.map((item) => {
        match = item.match(rx);
        output.push(match);
    });
    };

    const sortedData = output.flat().sort((a, b) => b-a);

    return (
        <div
            className=''
            ref={ref}>

            {title && (
                <p className='type-style-4'>{title}</p>
            )}
            <div className='h-[262px] mt-40 sm:mt-35 md:mt-40'>
                <div
                    className='border-b border-grey flex flex-row items-end justify-between gap-10 h-full'
                    style={gradientStyle}>
                    {sortedData.map((item, i) => {
                        let barBg = {};
                        if (graphColors) {
                            barBg = getColorStyles(graphColors[i]).backgroundColor;
                        } else {
                            barBg = '#FC5200';
                        };
                        const heightValue = parseFloat((item / sortedData[0]) * 100);
                        const barStyle = {
                            height: `${(heightValue)}%`,
                            backgroundColor: barBg
                        };
                        return (
                            <>
                                <div
                                    className={`w-full rounded-[2px] relative bg-strava-orange scale-y-0 origin-bottom transition duration-700 ${wasEverVisible ? 'scale-y-100' : ''}`}
                                    key={i}
                                    style={barStyle}>
                                    <div className='truncate text-start type-style-7 font-normal text-light-grey absolute top-0 left-0 right-0 -mt-[20px]'>
                                        <span>{graphData[i]}</span>
                                    </div>
                                    <div className='truncate text-start type-style-7 font-normal text-light-grey absolute bottom-[-20px] left-0 right-0 mt-[20px]'>
                                        <span>{graphLabels[i]}</span>
                                    </div>
                                </div>
                            </>
                        );
                    })}
                </div>
                {description &&
                    <figcaption className='w-full type-style-7 text-dark-grey whitespace-pre-wrap mt-30'>
                        {description}
                    </figcaption>
                }
            </div>
        </div>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

ModuleGraphItem.propTypes = {
    description: PropTypes.string,
    graphLabels: PropTypes.array,
    graphData: PropTypes.array,
    title: PropTypes.string,
    graphColors: PropTypes.array,
    singleGraphEditorialVariant: PropTypes.bool
};

export default ModuleGraphItem;
